import { Switch } from "shared/components/forms/Switch";
import { Tabs } from "shared/components/Tabs";

interface LayoutHeaderProps {
  unreadOnly: boolean;
  toggleUnreadOnly: () => void;
  tab: string;
  onTabChange: (tab: string) => void;
  unreadTotalCount: number;
}

export const LayoutHeader = (props: LayoutHeaderProps) => {
  const { unreadOnly, toggleUnreadOnly, tab, onTabChange, unreadTotalCount } =
    props;

  return (
    <div className="divide-y divide-alpha-40">
      <div className="flex gap-4 p-6">
        <h1 className="text-2xl font-bold">Notifications</h1>
        <Switch
          label="Only unread"
          wrapperClassName="mt-2"
          className="text-sm font-medium text-content-500"
          checked={unreadOnly}
          onChange={() => toggleUnreadOnly()}
        />
      </div>

      <div className="p-4 pb-0">
        <Tabs
          selected={tab}
          setActiveTab={(t) => onTabChange(t)}
          tabs={["mention"]}
          variant="underline"
          tabClassName="!px-0"
          displayMap={{
            mention: (
              <p className="mb-2">
                Mentions{" "}
                {unreadTotalCount ? (
                  <span className="px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded-md font-bold">
                    {unreadTotalCount}
                  </span>
                ) : (
                  ""
                )}
              </p>
            )
          }}
        />
      </div>
    </div>
  );
};
